"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPicker = void 0;
const react_1 = __importStar(require("react"));
const _ui_1 = require("@ui");
const color_1 = __importDefault(require("@app/util/color"));
require("./index.scss");
const Color = ({ isSelected, onChange, color, disabled }) => {
    return (react_1.default.createElement("div", { onClick: disabled ? undefined : onChange, className: 'ds-cpicker-c', style: { backgroundColor: `#${color}` } }, isSelected && react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.check, color: _ui_1.Icon.COLORS.WHITE })));
};
const ColorPicker = ({ value, onChange, maxColors, disabled = false, }) => {
    const [colors, setColors] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        const COLORS = [...color_1.default.getDefaultColors()];
        if (value && !COLORS.includes(value)) {
            COLORS.unshift(value);
            COLORS.pop();
        }
        setColors(COLORS);
    }, []);
    return (react_1.default.createElement("div", { className: 'ds-cpicker' },
        react_1.default.createElement("div", { className: 'ds-cpicker-base' }, colors.map((color, idx) => {
            if (maxColors && idx >= maxColors)
                return null;
            return (react_1.default.createElement(Color, { key: color, onChange: () => onChange(color), disabled: disabled, color: color, isSelected: color === value }));
        }))));
};
exports.ColorPicker = ColorPicker;
